"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Link = require("./Link");

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SortSelector = function SortSelector(_ref) {
  var _ref$Link = _ref.Link,
      Link = _ref$Link === undefined ? _Link2.default : _ref$Link,
      hideSortOptions = _ref.hideSortOptions,
      sortOptions = _ref.sortOptions,
      currentSort = _ref.currentSort,
      permalink = _ref.permalink;
  return _react2.default.createElement(
    "div",
    { className: "menuarea" },
    _react2.default.createElement(
      "div",
      { className: "spacer" },
      _react2.default.createElement(
        "span",
        { className: "dropdown-title lightdrop" },
        "sorted by:"
      ),
      _react2.default.createElement(
        "div",
        { className: "dropdown lightdrop" },
        _react2.default.createElement(
          "span",
          { className: "selected" },
          currentSort
        )
      ),
      !hideSortOptions && _react2.default.createElement(
        "div",
        { className: "drop-choices lightdrop" },
        sortOptions.map(function (sortName) {
          return sortName !== currentSort && _react2.default.createElement(
            Link,
            {
              key: sortName,
              className: "choice",
              href: permalink + "?sort=" + sortName
            },
            sortName
          );
        })
      )
    ),
    _react2.default.createElement("div", { className: "spacer" })
  );
};

exports.default = SortSelector;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/SortSelector.js
// module id = 307
// module chunks = 0